module.exports = __webpack_public_path__ + "assets/f3b84dd5bf23ff4290d8312fb0672a07.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet-1.mp3
 ** module id = 222
 ** module chunks = 0
 **/